export default __webpack_public_path__ + "static/media/package.95fca7ab.svg";